<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="类型">
<!--                  <el-input  v-model="queryForm.itemType"></el-input>-->
                  <el-select
                      v-model='queryForm.itemType'
                      placeholder='请选择类型'
                      size='small'
                      clearable
                      style='width: 176px'
                  >
                      <el-option
                          v-for='item in incomeSendTypeEnumList'
                          :key='item.key'
                          :label='item.value'
                          :value='item.key'
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="名称">
                  <el-input  style='width: 176px' v-model="queryForm.itemName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelIncomeSubItemList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button size="small" type="primary" @click="addModelIncomeSubItem">新建</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportModelIncomeSubItemList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshModelIncomeSubItemList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelIncomeSubItemList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="itemType"
        label="类型"
        min-width="180"
      >
          <template slot-scope="scop">
              {{computeSendType(scop.row.itemType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="itemName"
        label="名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="openDialog(scop.row.id, scop.row.itemType)">
                  <span class="operation-label">管理</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelIncomeSubItemStates[modelIncomeSubItemState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelIncomeSubItem"
          ref="modelIncomeSubItemForm"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <el-form-item
            label="类型"
            prop="itemType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelIncomeSubItem.itemType"-->
<!--              :disabled="modelIncomeSubItemState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  v-model='modelIncomeSubItem.itemType'
                  placeholder='请选择类型'
                  :disabled="modelIncomeSubItemState == 'check'"
                  size='small'
                  clearable
                  style='width: 176px'
              >
                  <el-option
                      v-for='item in incomeSendTypeEnumList'
                      :key='item.key'
                      :label='item.value'
                      :value='item.key'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="名称"
            prop="itemName"
          >
            <el-input
              size="small"
              style='width: 176px'
              v-model="modelIncomeSubItem.itemName"
              :disabled="modelIncomeSubItemState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelIncomeSubItemState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <el-drawer
          title="子项管理"
          :visible.sync="isShow"
          direction="rtl"
          size="60%"
          :destroy-on-close="true"
          :show-close="true"
          :wrapperClosable="true"
          @close="closeDrawer"
      >
          <ModelIncomeSubItemList ref="lists"></ModelIncomeSubItemList>
      </el-drawer>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ModelIncomeSubItemList from '@/components/model/ModelIncomeSubItemList.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ModelIncomeSubItemList
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelIncomeSubItemList();
                    this.getModelIncomeSubItemList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelIncomeSubItemList();
                    this.getModelIncomeSubItemList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //
                     itemType: '', //类型
                     itemName: '', //名称
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelIncomeSubItemState: 'add',
                modelIncomeSubItemStates: {
                    add: '新建子分红管理',
                    check: '查看子分红管理',
                    edit: '修改子分红管理'
                },
                isShow: false,
                multipleSelection: [],
                modelIncomeSubItemList: [],
                modelIncomeSubItem: {
                    id: '', //
                    itemType: '', //类型
                    itemName: '', //名称
                },
                btnLoading: false,

                rules: {
                    itemType: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
                    itemName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                },

                incomeSendTypeEnumList: []
            };
        },
        created() {
            this.getModelIncomeSubItemList();
            this.getIncomeSendTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetModelIncomeSubItemList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelIncomeSubItemList = [];
            },
            resetDialog() {
                this.modelIncomeSubItemState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      itemType: '', //类型
                      itemName: '', //名称
                };
                this.getModelIncomeSubItemList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelIncomeSubItem = {
                      id: '', //
                      itemType: '', //类型
                      itemName: '', //名称
                };
            },
            // 获取发放范围枚举
            getIncomeSendTypeEnum() {
                get('/mpp/utils/getEnum', {
                    enumType: 'income_sub_item_type'
                }).then((res) => {
                    if (res.success) {
                        this.incomeSendTypeEnumList = res.enumList;
                    }
                });
            },
            openDialog(modelIncomeSubItemId, typeNum) {
                this.isShow = true;
                this.$nextTick(()=>{
                    this.$refs.lists.init(modelIncomeSubItemId, typeNum)
                })
            },
            closeDrawer(){
                this.isShow = false;
            },
            submitForm() {
                if (this.modelIncomeSubItemState == 'add') {
                    this.$refs.modelIncomeSubItemForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/incomesubitem/add`,{ ...this.modelIncomeSubItem }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelIncomeSubItemList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelIncomeSubItemState == 'edit') {
                    this.$refs.modelIncomeSubItemForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/incomesubitem/edit`,{ ...this.modelIncomeSubItem }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelIncomeSubItemList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelIncomeSubItem() {
                this.showDialog = true;
                this.modelIncomeSubItemState = 'add';
            },
            checkModelIncomeSubItem(modelIncomeSubItemId) {
                console.log(modelIncomeSubItemId);
                this.currentModelIncomeSubItemId = modelIncomeSubItemId;

                this.getModelIncomeSubItemById();
                this.showDialog = true;
                this.modelIncomeSubItemState = 'check';
            },
            editModelIncomeSubItem(modelIncomeSubItemId) {
                console.log('modelIncomeSubItem', modelIncomeSubItemId);
                if (modelIncomeSubItemId) {
                    this.currentModelIncomeSubItemId = modelIncomeSubItemId;
                    this.getModelIncomeSubItemById();
                } else {
                    this.modelIncomeSubItem = { ...this.modelIncomeSubItem, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelIncomeSubItemState = 'edit';
            },
            computeSendType(type) {
                for (let i = 0; i < this.incomeSendTypeEnumList.length; i++) {
                    if (this.incomeSendTypeEnumList[i].key == type) {
                        return this.incomeSendTypeEnumList[i].value;
                    }
                }
            },
            deleteModelIncomeSubItem(modelIncomeSubItemId) {
                let ids = '';
                if (modelIncomeSubItemId) {
                    ids = modelIncomeSubItemId;
                } else {
                    ids = this.multipleSelection.map((modelIncomeSubItem) => modelIncomeSubItem.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/incomesubitem/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelIncomeSubItemList();
                                this.getModelIncomeSubItemList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelIncomeSubItemList() {
                this.resetModelIncomeSubItemList();
                this.getModelIncomeSubItemList();
            },
            getModelIncomeSubItemList(query = {}) {
                this.loading = true;
                get(`/model/incomesubitem/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelIncomeSubItemList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelIncomeSubItemById() {
                get(`/model/incomesubitem/get`,{ id: this.currentModelIncomeSubItemId }).then((res) =>{
                    if(res.success){
                      this.modelIncomeSubItem = { ...this.modelIncomeSubItem, ...res.modelIncomeSubItem };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelIncomeSubItemList() {
                //this.btnLoading = true;
                exprotExcel(`/model/incomesubitem/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/incomesubitem/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/incomesubitem/importData`,formData);
              this.refreshModelIncomeSubItemList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelIncomeSubItemList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelIncomeSubItemList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>